import type { MouseEventHandler } from 'react';
import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { openPricingModal } from '../utils/url/pricingPath';
import type { PlanFeatureKey } from './PricingConfig';
import UpgradeButton from './UpgradeButton';

type PricingModalButtonProps = {
  feature: PlanFeatureKey | undefined;
  onClick?: MouseEventHandler;
} & Pick<
  React.ComponentProps<typeof UpgradeButton>,
  'children' | 'size' | 'variant'
>;

const PricingModalButton = ({
  feature,
  onClick,
  ...props
}: PricingModalButtonProps) => {
  const dispatch = useAppDispatch();
  const showPricing: React.MouseEventHandler | undefined = feature
    ? (event) => {
        onClick?.(event);
        openPricingModal(dispatch, feature);
      }
    : undefined;
  return <UpgradeButton onClick={showPricing} {...props} />;
};

export default PricingModalButton;
